import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ButtonInfoNormal } from "../generic/common/ButtonInfoNormal";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { TextLoca } from "../generic/text/TextLoca";
import { IdTooltipAnchor, TooltipText } from "../tooltip";
import { ContextMenuButtonsDOM } from "./ContextMenuButtonsDOM";
export var ContextMenuDetails = React.memo(function (_a) {
    var building = _a.building, canUpgrade = _a.canUpgrade, canMove = _a.canMove, descriptionDisplay = _a.descriptionDisplay, hasDiscount = _a.hasDiscount, onInfo = _a.onInfo, onUpgrade = _a.onUpgrade, onMove = _a.onMove, position = _a.position, showBouncingArrow = _a.showBouncingArrow;
    var hoverStyle = getStyle(position);
    return (React.createElement("div", { className: "flex context-menu-details " + IdStyles.ContextMenuBalloon, style: hoverStyle },
        React.createElement("div", { className: "flex flex--spaced flex--aligned context-menu-buttons-info-container" },
            React.createElement(TooltipText, { id: IdLoca.tooltip_moreInfo_web, anchor: IdTooltipAnchor.Bottom },
                React.createElement(ButtonInfoNormal, { onClick: onInfo },
                    React.createElement(Icon, { icon: IdIcon.InfoIcn, styleId: IdStyles.IconMedium })))),
        React.createElement("div", { className: "flex flex--stacked flex--guts context-menu-title-wrapper" },
            React.createElement("div", null,
                React.createElement(TextLoca, { className: IdStyles.HeadlineOne, id: building.balancing.locaKey })),
            React.createElement("div", { className: IdStyles.TextButtonHeading }, descriptionDisplay)),
        React.createElement(ContextMenuButtonsDOM, { building: building, canMove: canMove, canUpgrade: canUpgrade, hasDiscount: hasDiscount, onMoveClick: onMove, onUpgradeClick: onUpgrade, showBouncingArrow: showBouncingArrow })));
});
var getStyle = function (_a) {
    var x = _a.x, y = _a.y;
    return ({
        left: x + "px",
        position: "absolute",
        top: y + "px",
    });
};



//////////////////
// WEBPACK FOOTER
// ./src/features/context-menu/ContextMenuDetails.tsx
// module id = 875
// module chunks = 3